export const MiguConfig = {
  appid:'513fe75dd6756c25d3a2ddd1c5f28765',
  appSecret:'ec72fb9433362893f257e8526b10bd1b', 
}
